import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    margin: '16px 0 40px 24px',
    width: '100%',
    overflow: 'auto',
  },
  styleHeader: {
    color: semanticColors.foreground.primary, // $color-gray-900
  },
  styleDescription: {
    color: semanticColors.foreground.secondary, // $color-gray-700
    fontWeight: foundations.typography.fontWeight.normal, // $font-weight-book
    lineHeight: '1rem',
  },
  mt40: {
    marginTop: '40px', // $unit-5
  },
  mb24: {
    marginBottom: '24px', // $unit-3
  },
  mt24: {
    marginTop: '24px', // $unit-3
  },
  mt16: {
    marginTop: '16px', // $unit-2
  },
  mt4: {
    marginTop: '4px', // $unit-half
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginTop: '16px',
  },
});
